export default {"src":"/_next/static/media/4quad.251d6572.svg","height":84,"width":840,"blurWidth":0,"blurHeight":0};